<template>
  <div>
    <pageTitle title='开通储值卡' />
      <div class='head'>
        <div class='hint'>
          温馨提示：为保证您的储值卡安全，初次使用会员储值功能需要先设置储值支付密码。
        </div>
        <div class='link'>
          <router-link to="/wallet/valueCardRule">查看储值优惠政策及使用规则 ></router-link>
        </div>
      </div>
      <inputBox :disabled='true' label='手机号码' :value='phone' />
      <inputBox hintMsg='请输入密码' label='密码' :secret='true' v-model='password'/>
      <inputBox hintMsg='请输入确认密码' label='确认密码' :secret='true' v-model='passCheck'/>
      <inputBox hintMsg='请输入图片验证码' label='图片验证码'  v-model='imgValid' extendType='icon' :extendSrc="TPFJM"  @extendHandler='getValidateCode'/>
      <inputBox hintMsg='请输入手机验证码' label='手机验证码'  v-model='phoneValid' extendType='button' extendSrc="获取验证码"  @extendHandler='getPhoneValid' :countDownSeconds='countDown'/>
      <div class="open">
        <mu-raised-button :fullWidth='true' label="立即开通"  primary @click='open'/>
      </div>
      <mu-toast id="alertline" v-if="toast" :message="hintMsg" @close="hideToast"/>
    </div>
</template>

<style lang="less">
// @import "../../assets/theme.less";
    .head{
        width:7.1rem;
        height:2.14rem;
        padding:0;
        background-color:white;
        .hint{
            height:1.32rem;
            padding:0.2rem 0.38rem;
            vertical-align:center;
            color:#FF9347;
            font-size:0.28rem;
            line-height:0.46rem;
            border-bottom:1px solid #E2E2E2;
        }
        .link{
            padding:0rem 0.38rem;
            a{
                color:#999999;
                font-size:0.28rem;
                line-height:0.82rem;
            }
        }
    }
    .open{
      width: 7.1rem;
      margin:0.2rem auto;
      border-radius:4px;
    }
</style>

<script>
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import api from '../../api/index.js'
import {} from '../../utils/valid.js'
export default {
  name: 'bottomNav',
  data () {
    return {
      phone:'',
      password:'',
      passCheck:'',
      imgValid:'',
      phoneValid:'',
      toast: false,
      hintMsg:'',
      TPFJM:'',
      countDown:0
    }
  },
  methods: {
      ...mapMutations({
          setMsg:'setG_rechargeMsg',setState:'setG_userState',setG_UserInfo: 'setG_UserInfo'
      }),
      goback(e){
        e.preventDefault()
        javascript:history.go(-1);
      },
      showToast (hintMsg) {
        if(hintMsg){
          this.hintMsg = hintMsg
        }
        this.toast = true
        if (this.toastTimer) clearTimeout(this.toastTimer)
        this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
      },
      hideToast () {
        this.toast = false
        if (this.toastTimer) clearTimeout(this.toastTimer)
      },
      valid(){
        if(this.phone.trim() == '')
        {
            this.hintMsg = '请输入手机号码'
            return false
        }
        if(this.password.trim() == ''){
            this.hintMsg = '请输入密码'
            return false
        }
        if(this.passCheck.trim() == '' || this.passCheck != this.password){
            this.hintMsg = '两次密码不一致'
            return false
        }
        if(this.phoneValid.trim() == ''){
            this.hintMsg = '请输入手机验证码'
            return false
        }
      },
      getPhoneValid(){
        if(this.imgValid.trim() == ''){
          this.showToast('请输入图形验证码')
          this.countDown = 5
          return
        }
        var params = new this.URLSearchParam();
        params.append('captcha', this.imgValid);
        params.append('templateName', 'Open');
        this.$http.post(api.sendSMSCode(),params.toParam()).then((res) => {
          if(res.Result){
            this.showToast('验证码已发送到您的默认手机上！')
            this.countDown = 30
          }
          else{ 
            this.countDown = 5
            this.showToast(res.Message)
            this.getValidateCode()
          }
        })
      },
      open(e){  
        if(this.valid() == false){
          this.showToast()
          return
        }
        else{
          var params = new this.URLSearchParam();
          params.append('phone', this.phone);
          params.append('firstPassword', this.password);
          params.append('cardType', '0');
          params.append('secondPassword', this.passCheck);
          params.append('smsVerification', this.phoneValid); 
          this.$http.post(api.openStoredValueCard(),params.toParam()).then((res) => {
            if(res.Result){
            //开通成功
              this.showToast(res.Data)
              var userInfo = this.userInfo
              userInfo.HasOpenStoreCard = true
              this.setG_UserInfo(userInfo)
              setTimeout(() => 
                this.$router.go(-1)
              ,2000)
            }
            else{ 
              this.showToast(res.Message)
              if('未登录' === res.Message){
                setTimeout(() => 
                  this.$router.push({ path: '/user/Login' }) 
                ,2000)
              }
            }
          })
        }
      },
      // 图片验证码
      getValidateCode() {
        this.TPFJM = api.getValidateCode();
      },
  },
  computed:{
      ...mapGetters({
        msg:'g_rechargeMsg',userInfo:'g_UserInfo',userState:'g_userState'
      })
  },
  activated(){
      if(typeof this.userInfo.sjno === "undefined"){
        this.showToast('请先登录')
        setTimeout(() => 
          this.$router.push({ path: '/user/Login' }) 
        ,2000)
      }
      this.phone = this.userInfo.sjno
      this.password = ''
      this.passCheck = ''
      this.phoneValid = ''
      this.imgValid = ''
      this.getValidateCode();
  },
}
</script>



// WEBPACK FOOTER //
// openValueCard.vue?21d257f8